export const Types = {
  SAVE_LIST_COMMENT: 'SAVE_LIST_COMMENT',
  SET_RECORD: 'SET_RECORD'
}
